<body class="container">
  <!-- app-header renders re3's own <header role="banner">, so this is a plain wrapper. -->
  <div id="site_header">
    <app-skip-to-content></app-skip-to-content>

    <div class="google-translate-bar">
      <h4>Translate page</h4>
      <div id="google_translate_element"></div>
    </div>

    <app-header></app-header>
  </div>
  <main>
    <!-- <app-breadcrumbs></app-breadcrumbs> -->

    <div class="row alert-colour">
      <div class="col-lg-2"></div>
      <div class="col-lg-8 m-2">
        <alert role="alert" tabindex="0"></alert>
      </div>
      <div class="col-lg-2"></div>
    </div>
    <ngx-spinner
      bdColor="rgba(51,51,51,0.8)"
      size="medium"
      color="rgb(50, 125, 156)"
      type="ball-scale-multiple"
    >
      <p style="font-size: 20px; color: #fff">
        {{ 'COMMON.LOADING' | translate }}
      </p>
    </ngx-spinner>

    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</body>
